import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      style={{
        top: '50%',
        transform: 'translateY(-50%)',
      }}
      {...props} />
  );
}

// Custom large centered toast for important messages
const showLargeToast = (title, description, type = 'success') => {
  const iconColors = {
    success: { bg: 'bg-green-100', text: 'text-green-600', border: 'border-green-500' },
    info: { bg: 'bg-blue-100', text: 'text-blue-600', border: 'border-blue-500' },
    warning: { bg: 'bg-yellow-100', text: 'text-yellow-600', border: 'border-yellow-500' },
    urgent: { bg: 'bg-red-100', text: 'text-red-600', border: 'border-red-500' },
  };
  const colors = iconColors[type] || iconColors.success;
  
  // Different icons based on type
  const icons = {
    success: (
      <svg className={`w-8 h-8 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
    info: (
      <svg className={`w-8 h-8 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    warning: (
      <svg className={`w-8 h-8 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
    urgent: (
      <svg className={`w-8 h-8 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  };
  const icon = icons[type] || icons.success;

  toast.custom((t) => (
    <div className="fixed inset-0 flex items-center justify-center z-[9999] pointer-events-none">
      <div className={`bg-white border-4 ${colors.border} rounded-2xl p-8 shadow-2xl max-w-md mx-4 pointer-events-auto animate-in fade-in zoom-in duration-300`}>
        <div className="flex flex-col items-center text-center gap-4">
          <div className={`w-16 h-16 ${colors.bg} rounded-full flex items-center justify-center`}>
            {icon}
          </div>
          <div>
            <h3 className="text-xl font-bold text-foreground mb-2">{title}</h3>
            <p className="text-muted-foreground">{description}</p>
          </div>
          <button 
            onClick={() => toast.dismiss(t)}
            className={`mt-2 px-6 py-2 ${type === 'urgent' ? 'bg-red-600 hover:bg-red-700' : 'bg-primary hover:bg-primary/90'} text-white rounded-full font-semibold transition-colors`}
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  ), { duration: 15000 });
}

// Show urgent email verification toast (red border, email icon)
const showEmailVerificationToast = (userEmail) => {
  showLargeToast(
    'Please verify your email',
    `We sent a verification link to ${userEmail}. Check your inbox (and spam folder) to complete registration.`,
    'urgent'
  );
};

// Alias for backward compatibility
const showVerificationToast = (title, description) => showLargeToast(title, description, 'success');

export { Toaster, toast, showVerificationToast, showLargeToast, showEmailVerificationToast }
